import Vue from "vue";
import VueRouter from "vue-router";
import routesData from "./routes";
Vue.use(VueRouter);
var routes = routesData;

var router = new VueRouter({
  routes,
  mode: "history",
});

// The base Facebook Pixel script (public/index.html) already fires the
// PageView for the initial load, so skip that first navigation here and
// only track subsequent client-side route changes.
var isInitialNavigation = true;
router.afterEach(() => {
  if (isInitialNavigation) {
    isInitialNavigation = false;
    return;
  }
  if (typeof window.fbq === "function") {
    window.fbq("track", "PageView");
  }
});

export default router;
